export default {
  s: '%d soniya',
  smicro: '%d s',
  smid: '%d son',

  ss: '%d soniya',
  ssmicro: '%d s',
  ssmid: '%d son',

  m: '%d daqiqa',
  mmicro: '%d dq',
  mmid: '%d dq',

  mm: '%d daqiqa',
  mmmicro: '%d dq',
  mmmid: '%d dq',

  h: '%d soat',
  hmicro: '%d so',
  hmid: '%d soat',

  hh: '%d soat',
  hhmicro: '%d so',
  hhmid: '%d soat',

  d: '%d kun',
  dmicro: '%d k',
  dmid: '%d kun',

  dd: '%d kun',
  ddmicro: '%d k',
  ddmid: '%d kun',
};
